import './TopCategoriesSection.scss';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { SubcategoryAPIHandler } from '../../../../services/NetworkClient/BackendAPIs/SubcategoryAPIhandler';
import { Subcategory } from '../../../../Models/SubCategory';
import { ErrorLogger } from '../../../../utils/Logger';
import CircularProgress from '@mui/material/CircularProgress';

const TopCategoriesSection = () => {
  const navigate = useNavigate();
  const [subcategories, setSubcategories] = useState<Subcategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Popular subcategory IDs to fetch
  const popularSubcategoryIds = [
    "68eac0d70940dfe4ddeab218", // Website Development
    "68eac0d90940dfe4ddeab220", // UI/UX Designing
    "68eac0db0940dfe4ddeab226", // Content Creation
    "68eac0dc0940dfe4ddeab22a", // College Application Essays
    "68eac0dd0940dfe4ddeab230", // Video Editing
    "68eac0de0940dfe4ddeab232", // Chartered Accountancy
  ];

  useEffect(() => {
    const fetchSubcategories = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const fetchPromises = popularSubcategoryIds.map(id => 
          SubcategoryAPIHandler.shared.getSubcategoryById(id)
        );
        
        const fetchedSubcategories = await Promise.all(fetchPromises);
        setSubcategories(fetchedSubcategories);
      } catch (err) {
        ErrorLogger.log(err, 'TopCategoriesSection.fetchSubcategories');
        setError('Failed to load categories. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchSubcategories();
  // eslint-disable-next-line
  }, []);

  const handleExploreAll = () => {
    navigate('/categories');
  };

  const handleCategoryClick = (subcategoryId: string) => {
    navigate(`/categories/subcategory/${subcategoryId}/giglist`);
  };

  if (loading) {
    return (
      <section className='top-categories-section'>
        <div className='categories-container'>
          <div className='loading-state'>
            <h1 className='categories-heading'>
              Equipped with modern day business services
            </h1>
            <p className='categories-subtitle'>
              to help you scale fast and achieve your business goals.
            </p>
            <CircularProgress size={24} thickness={5} sx={{ color: "#1c1c1c" }} />
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className='top-categories-section'>
        <div className='categories-container'>
          <div className='error-state'>
            <h1 className='categories-heading'>
              Equipped with modern day business services
            </h1>
            <p className='categories-subtitle'>
              to help you scale fast and achieve your business goals.
            </p>
            <div className='error-message'>{error}</div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className='top-categories-section'>
      <div className='categories-container'>
        {/* Heading */}
        <h1 className='categories-heading'>
          Equipped with modern day business services
        </h1>
        <p className='categories-subtitle'>
          to help you scale fast and achieve your business goals.
        </p>

        {/* Categories Grid */}
        <div className='categories-grid'>
          {subcategories.map((subcategory, index) => (
            <div 
              key={subcategory.id}
              className='category-card'
              onClick={() => handleCategoryClick(subcategory.id)}
            >
              <div className='card-header'>
                <div 
                  className='card-background-image'
                  style={{ backgroundImage: `url(${subcategory.headerImageUrl})` }}
                >
                  <div className='category-tag'>
                    {subcategory.name}
                  </div>
                </div>
              </div>
              <div className='card-content'>
                <div className='card-title'>
                  {subcategory.tagline}
                </div>
                <div className='card-icons'>
                  <div className='icon-arrow'>↗</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Explore All Button */}
        <button className='explore-all-button' onClick={handleExploreAll}>
          Explore All
        </button>
      </div>
    </section>
  );
};

export default TopCategoriesSection;
